import { render, staticRenderFns } from "./ClaimTransactions.vue?vue&type=template&id=77a57006"
import script from "./ClaimTransactions.vue?vue&type=script&lang=js"
export * from "./ClaimTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports